import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { FileService } from '../file.service';
import * as fileActions from './file.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { File } from '../../_models/file';
import { Workstep } from '../../_models/workstep';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as rootActions from '../../state/app.actions';
import * as fromRoot from '../../state/app.reducer';
import { Router } from '@angular/router';
import { Location, LocationStrategy } from '@angular/common';


import { Globals } from '../../_globals/globals';

@Injectable()
export class FileEffects {

    @Effect()
    loadFile$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.LoadFiles),
        mergeMap((action: fileActions.LoadFiles) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadFiles =');
                // console.log(action.payload);

                return this.fileService.getFiles(action.payload).pipe(
                    map((files: File[]) => {
                        this.changingLoading(false);
                        return new fileActions.LoadFilesSuccess(files);
                    }),
                    catchError(err => of(new fileActions.LoadFilesFail(err)))
                )
            }
        )
    );

    // NOTA: Lanzar directamente otra acción sin llamar a ningún servicio.
    // @Effect()
    // loadFileSuccess$ = this.actions$.pipe(
    //     ofType(fileActions.FileActitonTypes.LoadFilesSuccess),
    //     map((action: rootActions.ChangeLoading) => (new rootActions.ChangeLoading(false)))
    // );

    // NOTA: sin usar Loading ni ventanas de información.
    // @Effect()
    // updateFile$: Observable<Action> = this.actions$.pipe(
    //     ofType(fileActions.FileActitonTypes.UpdateFile),
    //     map((action: fileActions.UpdateFile) => action.payload),
    //     mergeMap(( file: File) =>
    //         this.fileService.updateFile(file).pipe(
    //         map(updatedFile => (new fileActions.UpdateFileSuccess(updatedFile))),
    //         catchError(err => of(new fileActions.UpdateFileFail(err)))
    //     ))
    // );

    @Effect()
    updateFile$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.UpdateFile),
        mergeMap((action: fileActions.UpdateFile) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateFile =');
                // console.log(action.payload);

                return this.fileService.updateFile(action.payload).pipe(
                    map((file: File) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server UpdateFile =');
                        console.log(file);
                        if (file !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/file', null, 'info');
                            return new fileActions.UpdateFileSuccess(file);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new fileActions.UpdateFileFail('ERROR UpdateFile effect.');
                        }
                    }),
                    catchError(err => of(new fileActions.UpdateFileFail(err)))
                )
            }
        )
    );

    @Effect()
    optimizerFile$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.OptimizerFile),
        mergeMap((action: fileActions.OptimizerFile) => {
                this.changingLoading(true);
                console.log('-->... Payload OptimizerFile =');
                // console.log(action.payload);

                return this.fileService.optimizerFile(action.payload).pipe(
                    map((file: any) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server OptimizerFile =');
                        // console.log(file);
                        if (file !== false) {
                            console.log('-->... optimizerFile Respuesta con contenido...');

                            // NOTA: Se llama a la función que hace que se pueda descargar
                            // directamente el archivo devuelto por el controlador.
                            if (action.payload.download === true || action.payload.download === 'true') {
                                this.downloadFile(file);
                            } else {
                                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            }

                            return new fileActions.OptimizerFileSuccess(file);
                        } else {
                            console.log('-->... optimizerFile Respuesta errónea...');
                            let result_msg = 'No se ha podido realizar la acción correctamente. NO existe el directorio indicado.';
                            this.showInfoModal(true, result_msg, '', null, 'alert');
                            return new fileActions.OptimizerFileFail('ERROR OptimizerFile effect.');
                        }
                    }),
                    catchError(err => of(new fileActions.OptimizerFileFail(err)))
                )
            }
        )
    );

    @Effect()
    infoFileList$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.InfoFileList),
        mergeMap((action: fileActions.InfoFileList) => {
                this.changingLoading(true);
                // console.log('-->... Payload OptimizerFile =');
                // console.log(action.payload);

                return this.fileService.getInfoFileList(action.payload).pipe(
                    map((fileList: any) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server InfoFileList =');
                        // console.log(fileList);
                        if (fileList !== false) {
                            console.log('-->... InfoFileList Respuesta con contenido...');

                            // this.showInfoModal(true, 'Se ha realizado la acción correctamente.', null, null, 'info');
                            return new fileActions.InfoFileListSuccess(fileList);
                        } else {
                            console.log('-->... InfoFileList Respuesta errónea...');
                            // this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new fileActions.InfoFileListFail('ERROR InfoFileList effect.');
                        }
                    }),
                    catchError(err => of(new fileActions.InfoFileListFail(err)))
                )
            }
        )
    );

    @Effect()
    CreateFile$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.CreateFile),
        mergeMap((action: fileActions.CreateFile) => {
                this.changingLoading(true);
                // console.log('-->... Payload CreateFile =');
                // console.log(action.payload);

                return this.fileService.createFile(action.payload).pipe(
                    map((file: File) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server CreateFile =');
                        // console.log(file);
                        if (file !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/file-list', null, 'info');
                            return new fileActions.CreateFileSuccess(file);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new fileActions.CreateFileFail('ERROR CreateFile effect.');
                        }
                    }),
                    catchError(err => of(new fileActions.CreateFileFail(err)))
                )
            }
        )
    );

    @Effect()
    deleteFile$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.DeleteFile),
        mergeMap((action: fileActions.DeleteFile) => {
                this.changingLoading(true);
                // console.log('-->... Payload DeleteFile =');
                // console.log(action.payload);

                return this.fileService.deleteFile(action.payload).pipe(
                    map((fileId: bigint) => {
                        this.changingLoading(false);
                        console.log('-->... Payload server DeleteFile =');
                        console.log(fileId);
                        if (fileId !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
                            return new fileActions.DeleteFileSuccess(fileId);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new fileActions.DeleteFileFail('ERROR DeleteFile effect.');
                        }
                    }),
                    catchError(err => of(new fileActions.DeleteFileFail(err)))
                )
            }
        )
    );

    // ---------------
    //  PASOS TRABAJO
    // ---------------

    @Effect()
    loadWorksteps$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.LoadWorksteps),
        mergeMap((action: fileActions.LoadWorksteps) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadFiles =');
                // console.log(action.payload);

                return this.fileService.getWorksteps(action.payload).pipe(
                    map((steps: Workstep[]) => {
                        this.changingLoading(false);
                        return new fileActions.LoadWorkstepsSuccess(steps);
                    }),
                    catchError(err => of(new fileActions.LoadWorkstepsFail(err)))
                )
            }
        )
    );


  // ----------------
  //    IMPRIMIR
  // ----------------
  @Effect()
  printFile$ = this.actions$.pipe(
    ofType(fileActions.FileActitonTypes.PrintFile),
    mergeMap((action: fileActions.PrintFile) => {
        this.changingLoading(true);
        console.log('--> Payload PrintFile:');
        console.log(action.payload);
        console.log(action.payload.action);

        return this.fileService.printFile(action.payload).pipe(
          map((response: any) => {
            this.changingLoading(false);
            console.log('--> Payload server PrintFile:');
            console.log(response);
            if (response) {
              console.log('--> RESPONSE:')
              console.log(response);

              if (response.action === 'SendEmail') {
                return new fileActions.SendEmail(response);
              } else {
                console.log('--> Effect PrintFile Se ha impreso correctamente el documento.');
                // this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/document', null, 'info');
                this.navigateSection('/document', response.section, response.back);

                return new fileActions.PrintFileSuccess(response);
              }
            } else {
              this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
              return new fileActions.PrintFileFail('ERROR PrintFile effect.');
            }
          }),
          catchError(err => of(new fileActions.PrintFileFail(err)))
        );
      }
    )
  );

  // ---- Hojas / Planchas
  @Effect()
  printSheets$ = this.actions$.pipe(
    ofType(fileActions.FileActitonTypes.PrintSheets),
    mergeMap((action: fileActions.PrintSheets) => {
        this.changingLoading(true);
        console.log('--> Payload PrintSheets:');
        console.log(action.payload);
        console.log(action.payload.action);

        return this.fileService.printSheets(action.payload).pipe(
          map((response: any) => {
            this.changingLoading(false);
            console.log('--> Payload server PrintSheets:');
            console.log(response);
            if (response) {
              console.log('--> RESPONSE:')
              console.log(response);

              if (response.action === 'SendEmail') {
                return new fileActions.SendEmail(response);
              } else {
                console.log('--> Effect PrintSheets Se ha impreso correctamente el documento.');
                // this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/document', null, 'info');
                this.navigateSectionNewTab('/document', response.section, response.back);

                return new fileActions.PrintSheetsSuccess(response);
              }
            } else {
              this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
              return new fileActions.PrintSheetsFail('ERROR PrintSheets effect.');
            }
          }),
          catchError(err => of(new fileActions.PrintSheetsFail(err)))
        );
      }
    )
  );

  // ---- Caballetes de corte
  @Effect()
  printEasels$ = this.actions$.pipe(
    ofType(fileActions.FileActitonTypes.PrintEasels),
    mergeMap((action: fileActions.PrintEasels) => {
        this.changingLoading(true);
        console.log('--> Payload PrintEasels:');
        console.log(action.payload);
        console.log(action.payload.action);

        return this.fileService.printEasels(action.payload).pipe(
          map((response: any) => {
            this.changingLoading(false);
            console.log('--> Payload server PrintEasels:');
            console.log(response);
            if (response) {
              console.log('--> RESPONSE:')
              console.log(response);

              if (response.error) {
                this.showInfoModal(
                  true,
                  response.error,
                  '',
                  null,
                  'alert'
                );
                return new fileActions.PrintEaselsFail(response);
              } else if (response.action === 'SendEmail') {
                return new fileActions.SendEmail(response);
              } else if (response.action === 'CreateV40') {
                console.log('--> Effect PrintEasels Se han creado los archivos correctamente.');
                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');

                // Modo de descarga para los archivos Turomas.
                this.downloadFile(response);

                return new fileActions.PrintEaselsSuccess(response);
              } else if (response.action === 'CreateLSW' || response.action === 'CreateLIOPT') {
                console.log('--> Effect PrintEasels Se han creado los archivos correctamente.');
                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');

                // Modo de descarga para los archivos Lisec.
                this.downloadLSWFiles(response);

                return new fileActions.PrintEaselsSuccess(response);
              } else if (response.action === 'CreateOTD') {
                console.log('--> Effect PrintEasels Se han creado los archivos correctamente.');
                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');

                // Modo de descarga para los archivos Intermac.
                this.downloadOTDFile(response);

                return new fileActions.PrintEaselsSuccess(response);
              } else if (response.action === 'CreateBTR') {
                console.log('--> Effect PrintEasels Se han creado los archivos correctamente.');
                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');

                // Modo de descarga para los archivos Bottero.
                this.downloadBTRFiles(response);

                return new fileActions.PrintEaselsSuccess(response);
              } else if (response.action === 'CreateELO') {
                console.log('--> Effect PrintEasels Se han creado los archivos correctamente.');
                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');

                // Modo de descarga para los archivos Bottero.
                this.downloadELOFiles(response);

                return new fileActions.PrintEaselsSuccess(response);
              } else if (response.action === 'CreateTEC') {
                console.log('--> Effect PrintEasels Se han creado los archivos correctamente.');
                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');

                // Modo de descarga para los archivos Tecnometal.
                this.downloadTECFiles(response);

                return new fileActions.PrintEaselsSuccess(response);
              } else if (response.action === 'CreateBendingCNC') {
                console.log('--> Effect PrintEasels Se ha creado el fichero de plegadora correctamente.');
                this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');

                this.downloadBendingMachineFile(response);

                return new fileActions.PrintEaselsSuccess(response);
              } else {
                console.log('--> Effect PrintEasels Se ha impreso correctamente el documento.');
                // this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/document', null, 'info');
                this.navigateSectionNewTab('/document', response.section, response.back);

                return new fileActions.PrintEaselsSuccess(response);
              }
            } else {
              this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
              return new fileActions.PrintEaselsFail('ERROR PrintEasels effect.');
            }
          }),
          catchError(err => of(new fileActions.PrintEaselsFail(err)))
        );
      }
    )
  );

  // ----------------
  //    MAKE CSV crea un archivo CSV en el servidor
  // ----------------
    @Effect()
    makeCsv$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.MakeCsv),
        mergeMap((action: fileActions.MakeCsv) => {
                this.changingLoading(true);
                // console.log('-->... Payload MakeCsv =');
                // console.log(action.payload);

                return this.fileService.makeCsv(action.payload).pipe(
                    map((response: number) => {

                        // console.log('--> MakeCsv RESPONSE:')
                        // console.log(response);

                        this.changingLoading(false);
                        return new fileActions.MakeCsvSuccess(response);
                    }),
                    catchError(err => of(new fileActions.MakeCsvFail(err)))
                )
            }
        )
    );

  // ----------------
  //    READ CSV que esté en el servidor el archivo.
  // ----------------
    @Effect()
    readCsv$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.ReadCsv),
        mergeMap((action: fileActions.ReadCsv) => {
                this.changingLoading(true);
                // console.log('-->... Payload ReadCsv =');
                // console.log(action.payload);

                return this.fileService.readCsv(action.payload).pipe(
                    map((response: number) => {

                        console.log('--> ReadCsv RESPONSE:')
                        // console.log(response);

                        // Se llama a la función que hace que se pueda descargar
                        // directamente el archivo desde el controlador.
                        this.downloadFile(response);

                        this.changingLoading(false);
                        return new fileActions.ReadCsvSuccess(response);
                    }),
                    catchError(err => of(new fileActions.ReadCsvFail(err)))
                )
            }
        )
    );

  // ----------------
  //    UPDATE CSV Mete informción de un CSV en la base de datos.
  // ----------------
    @Effect()
    updateFileCSV$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.UpdateFileCSV),
        mergeMap((action: fileActions.UpdateFileCSV) => {
                this.changingLoading(true);
                // console.log('-->... Payload UpdateFileGlass =');
                // console.log(action.payload);

                return this.fileService.updateFileCSV(action.payload).pipe(
                    map((fileOut: any) => {
                        this.changingLoading(false);
                        // console.log('-->... Payload server UpdateFileCSV =');
                        // console.log(fileOut);
                        if (fileOut !== null) {
                            this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '/file-edit', null, 'info');
                            return new fileActions.UpdateFileCSVSuccess(fileOut);
                        } else {
                            this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
                            return new fileActions.UpdateFileCSVFail('ERROR UpdateFileCSV effect.');
                        }
                    }),
                    catchError(err => of(new fileActions.UpdateFileCSVFail(err)))
                )
            }
        )
    );

    // ----------------------------------
    // 		PIEZAS OPTIMIZADAS
    // ----------------------------------

    @Effect()
    loadOptiPiece$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.LoadOptiPiece),
        map((action: fileActions.LoadOptiPiece) => action.payload),
        mergeMap(( data: any) =>
            this.fileService.saveOptiPiece(data).pipe(
            map(dataOptiPiece => (new fileActions.LoadOptiPieceSuccess(dataOptiPiece))),
            catchError(err => of(new fileActions.LoadOptiPieceFail(err)))
        ))
    );
    
    // ----------------------------------
    // 		PIEZAS FLOOR
    // ----------------------------------
    
    @Effect()
    loadPiece$ = this.actions$.pipe(
        ofType(fileActions.FileActitonTypes.LoadPiece),
        mergeMap((action: fileActions.LoadPiece) => {
                this.changingLoading(true);
                // console.log('-->... Payload LoadPiece =');
                // console.log(action.payload);

                return this.fileService.getPiece(action.payload).pipe(
                    map((dataPiece: any) => {
                        this.changingLoading(false);
                        return new fileActions.LoadPieceSuccess(dataPiece);
                    }),
                    catchError(err => of(new fileActions.LoadPieceFail(err)))
                )
            }
        )
    );

  // ----------------
  // 	EMAILS
  // ----------------
  @Effect()
  sendEmail$ = this.actions$.pipe(
    ofType(fileActions.FileActitonTypes.SendEmail),
    mergeMap((action: fileActions.SendEmail) => {
        this.changingLoading(true);
        console.log('--> Payload SendEmail:');
        console.log(action.payload);

        return this.fileService.sendEmail(action.payload).pipe(
          map((response: any) => {
            this.changingLoading(false);
            console.log('--> Payload server SendEmail:');
            console.log('--> RESPONSE:')
            console.log(response);

            // if (response) {
            //   this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
            //   return new fileActions.SendEmailSuccess(response);
            // } else {
            //   this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
            //   return new fileActions.SendEmailFail('ERROR SendEmail effect.');
            // }
            if (response === null || response === [] || response === undefined || response === '') {
              this.showInfoModal(true, 'No se ha podido realizar la acción correctamente.', '', null, 'alert');
              return new fileActions.SendEmailFail('ERROR SendEmail effect.');
            } else {
              this.showInfoModal(true, 'Se ha realizado la acción correctamente.', '', null, 'info');
              return new fileActions.SendEmailSuccess(response);
            }
          }),
          catchError(err => of(new fileActions.SendEmailFail(err)))
        );
      }
    )
  );

    // -----------------------------

    constructor(private actions$: Actions,
                private fileService: FileService,
                private storeRoot: Store<fromRoot.State>,
                private router: Router,
                private globals: Globals,
                private location: Location,
                private locationStrategy: LocationStrategy) {

    }

    changingLoading(value: boolean) {
        console.log('---->>>>.... Ejecutando changingLoading: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading(value));
    }
    
    changingLoading1(value: boolean) {
        console.log('---->>>>.... Ejecutando movement changingLoading1: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading1(value));
    }

    changingLoading2(value: boolean) {
        console.log('---->>>>.... Ejecutando movement changingLoading2: ' + value);
        this.storeRoot.dispatch( new rootActions.ChangeLoading2(value));
    }

    showInfoModal(value: boolean, info: string, link: string, param: null, skin: string) {
        console.log('---->>>>.... Ejecutando File Effect showInfoModal: ' + value + ' ;Param: ' + param + ' ;Info: ' + info);
        this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin }));
    }

    // Función que cambia el nombre del archivo que se va a descargar.
    openData(data, fileName) {

        console.log('--> fileEffect openData...');
        let a = document.createElement('a');
        document.body.appendChild(a);

        // const json = JSON.stringify(data);
        const blob = new Blob([data], {type: 'octet/stream'});
        const url = window.URL.createObjectURL(blob);

        console.log('--> fileEffect openData url');
        console.log(url);

        a.href = url;
        a.download = fileName;

        // No hace falta añadir el elemento al body.
        // document.body.appendChild(a);

        a.click();

        // Si se añade el elemento luego habría que eliminarlo.
        // a.parentNode.removeChild(a);

        // Una vez terminado todo hay que liberar el espacio ocupado al crear la URL con el blob.
        window.URL.revokeObjectURL(url);
    }
    
    async openZipLSWData(data, fileName) {

        console.log('--> openZipLSWData...');
        
        let zip_content = data; //.data;
        
        console.log(zip_content);
        
        let a = document.createElement('a');
        document.body.appendChild(a);
        
        const blob = new Blob([zip_content], {type: 'application/octet-stream'});
        
        // console.log('--> openZipLSWData blob:');
        // console.log(blob);
        
        // Se abre el archivo que se guardó en el servidor
        window.open('./assets/attachments/lisec/' + fileName);
        
        /*
        const url = window.URL.createObjectURL(blob);
        
        console.log('--> openZipLSWData url:');
        console.log(url);

        a.href = url;
        a.download = fileName;

        a.click();

        // Una vez terminado todo hay que liberar el espacio ocupado al crear la URL con el blob.
        window.URL.revokeObjectURL(url); */
    } // End function openZipLSWData.

    // Función que sirve para descsagar el contenido de un archivo.
    downloadFile(data: any) {
        console.log('--> fileEffect downloadFile: Descargando archivo...');
        // console.log(data);

        let turomas_JSON = data['turomas_JSON'];
        let file_name = data['file_name'];
    /*
        const blob = new Blob([data], { type: 'text/csv' });
        // const blob = new Blob([data], { type: 'application/json' });

        const url = window.URL.createObjectURL(blob);

        console.log('--> downloadFile nombre archivo:');
        console.log(url);

        // NOTA: Para obtener el nombre aleatorio que se le ha asignado al archivo de descarga.
        // let name = url.split('/');
        // console.log(name[name.length - 1]);

        // window.open(url);
    */
        // ---------

        if (file_name) {
            // Si se quiere asignar un nombre concreto al archivo que se va a descargar.
            this.openData(turomas_JSON, file_name); // 'turomas_v40.json');
        }

    } // End function downloadFile

    // Función que sirve para descsagar el contenido de un archivo.
    downloadLSWFiles(data: any) {
        console.log('--> fileEffect downloadLSWFiles: Descargando archivos...');
        console.log(data);

        let content_list = data['content'];
        let file_name_list = data['file_name'];
        
        this.openZipLSWData(content_list, file_name_list);
/*
        if (content_list.tra1) {

            console.log('--> Recibido contendio fichero tra1_nue.fil. Descargando...');
            // Si se quiere asignar un nombre concreto al archivo que se va a descargar.
            this.openData(content_list.tra1, file_name_list.tra1);
        }

        if (content_list.tra2) {
            console.log('--> Recibido contendio fichero tra2_nue.fil. Descargando...');
            this.openData(content_list.tra2, file_name_list.tra2);
        }

        if (content_list.tra3) {
            console.log('--> Recibido contendio fichero tra3_nue.fil. Descargando...');
            this.openData(content_list.tra3, file_name_list.tra3);
        }

        if (content_list.tra4) {
            console.log('--> Recibido contendio fichero tra4_nue.fil. Descargando...');
            this.openData(content_list.tra4, file_name_list.tra4);
        }
        
        if (content_list.glad) {
            console.log('--> Recibido contendio fichero glad.fil. Descargando...');
            this.openData(content_list.glad, file_name_list.glad);
        }
        
        if (content_list.glak) {
            console.log('--> Recibido contendio fichero glak.fil. Descargando...');
            this.openData(content_list.glak, file_name_list.glak);
        }
        
        if (content_list.glas) {
            console.log('--> Recibido contendio fichero glas.fil. Descargando...');
            //this.openData(content_list.glas, file_name_list.glas);
        } // */

    } // End function downloadLSWFiles
    
    downloadOTDFile(data: any) {
        console.log('--> fileEffect downloadOTDFile: Descargando archivo...');
        console.log(data);

        let content = data['intermac_OTD'];
        let file_name = data['file_name'];

        if (file_name) {
            // Si se quiere asignar un nombre concreto al archivo que se va a descargar.
            this.openData(content, file_name);
        }

    } // End function downloadOTDFile
    
    // Función que sirve para descsagar varios archivos.
    downloadBTRFiles(data: any) {
        console.log('--> fileEffect downloadBTRFiles: Descargando archivos...');
        console.log(data);

        let content_list = data['content'];
        let file_name_list = data['file_name'];

        if (content_list.tra1) {

            console.log('--> Recibido contendio fichero tra1_nue.fil. Descargando...');
            // Si se quiere asignar un nombre concreto al archivo que se va a descargar.
            this.openData(content_list.tra1, file_name_list.tra1);
        }
		/*
        if (content_list.tra2) {
            console.log('--> Recibido contendio fichero tra2_nue.fil. Descargando...');
            this.openData(content_list.tra2, file_name_list.tra2);
        } */

    } // End function downloadBTRFiles
    
    // Función que sirve para descsagar varios archivos.
    downloadELOFiles(data: any) {
        console.log('--> fileEffect downloadELOFiles: Descargando archivos...');
        console.log(data);

        let content_list = data['content'];
        let file_name_list = data['file_name'];

        if (content_list.nst) {

            console.log('--> Recibido contendio fichero NST. Descargando...');
            // Si se quiere asignar un nombre concreto al archivo que se va a descargar.
            this.openData(content_list.nst, file_name_list.nst);
        }
		
        if (content_list.cmt) {
            console.log('--> Recibido contendio fichero CMT. Descargando...');
            this.openData(content_list.cmt, file_name_list.cmt);
        }
        
        if (content_list.dcs) {
            console.log('--> Recibido contendio fichero DCS. Descargando...');
            this.openData(content_list.dcs, file_name_list.dcs);
        } 

    } // End function downloadELOFiles
    
    // Función que sirve para descsagar varios archivos.
    downloadTECFiles(data: any) {
        console.log('--> fileEffect downloadTECFiles: Descargando archivos...');
        console.log(data);

        let content_list = data['content'];
        let file_name_list = data['file_name'];

        if (content_list) {

            console.log('--> Recibido contendio fichero tecnometal.R01. Descargando...');
            // Si se quiere asignar un nombre concreto al archivo que se va a descargar.
            this.openData(content_list, file_name_list);
        }

    } // End function downloadTECFiles

    downloadBendingMachineFile(data: any) {
        console.log('--> fileEffect downloadBendingMachineFile: Descargando archivo...');
        console.log(data);

        const content = data ? data['content'] : null;
        const file_name = data && data['file_name'] ? data['file_name'] : '00MULTI.job';

        if (content) {
            this.openData(content, file_name);
        }
    }

    navigateSection(section: string, param1: string, param2: string): void {

        console.log('-> navigateSection: param1 = ' + param1 + '; param2 = ' + param2);
        console.log(section);

        this.router.navigate([section, param1, true, param2]);
    }

    navigateSectionNewTab(section: string, param1: string, param2: string): void {

        console.log('-> navigateSectionNewTab: param1 = ' + param1 + '; param2 = ' + param2);
        console.log(section);

        // this.router.navigate([section, param1, true, param2]);


        // NOTA: Si usamos el componente para URL externas. para que se abra en otra pestaña del navegador.
        let url_aux = '#/document/' + param1 + '/false/' + param2;

        this.router.navigate(['/externalRedirect', { externalUrl: url_aux }]);
    }
}
